import { FEATURE_FLAGS_NAMES, FeatureFlag } from './feature-flag.model';

export const isFeatureFlagActive = (flags: FeatureFlag[] | undefined, name: FEATURE_FLAGS_NAMES) =>
    flags?.some((flag) => flag.name === name && flag.active) ?? false;
